var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4787 0.849609H14.8595L9.65946 6.83274L15.7992 14.946H10.9751L7.21609 10.0279L2.89319 14.946H0.512472L6.08838 8.55563L0.199219 0.849609H5.14862L8.56307 5.36045L12.4787 0.849609ZM11.633 13.505H12.9486L4.42813 2.1966H2.98717L11.633 13.505Z",
    fill: "#AD2624"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup0);
export default __webpack_public_path__ + "static/media/group0.cfdee886f65fa251faf22e938d368c41.svg";
export { ForwardRef as ReactComponent };